import {
  Badge,
  Box,
  Button,
  Flex,
  Grid,
  rem,
  Select,
  TextInput,
} from "@mantine/core";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_SortingState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";

import { DatePickerInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import {
  IconBrandBootstrap,
  IconBuildingWarehouse,
  IconFileExport,
  IconSearch,
  IconTimeDuration15,
} from "@tabler/icons-react";
import dayjs from "dayjs";
import {
  repositoryDelivery,
  repositoryPos,
} from "../../../_base/_const/_constVar";
import BreadcrumbLayout1 from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import LoadingOverlayCustom from "../../../common/LoadingOverLayCustom/LoadingOverLayCustom";
import { BASE_API_DELIVERY } from "../../../config";
import { _localization } from "../../../config/location";
import { MessageResponse } from "../../../model/MessageResponse";
import { SelectListItemModel } from "../../../model/SelectListItem";
import { green } from "../../../const/variables";
import { useLocation } from "react-router-dom";

type ColumnPinningType = { left?: string[]; right?: string[] };

// Biên bản kiểm kê hàng bảo hành
const InventoryRecord = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<DeliveryTransaction[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    [],
  );
  const [globalFilter, setGlobalFilter] = useState("");
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [visible, { toggle, close, open }] = useDisclosure(false);

  //Mã nhân viên
  const [dataInvCode, setDataInvCode] = useState<SelectListItemModel[]>([]);
  //dataExportExcel

  const sizeGrid = { base: 12, sm: 6, md: 4, lg: 2.4, xl: 2 };
  const [dataBranch, setDataBranch] = useState<any[]>([]);
  type DeliveryTransaction = {
    ma_vt: string;
    ten_vt: string;
    tong_hop_ma_kho: string;
    serials_no_kho: string;
    serials_no_khach: string;
    serials_kho_gui_ncc: string;
    serials_khach_gui_ncc: string;
    no_kho: number;
    no_khach: number;
    kho_gui_ncc: number;
    khach_gui_ncc: number;
    tong_no: number;
    tong_gui_ncc: number;
  };

  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";

  const innitStateSearch = React.useMemo(
    () => ({
      KeySearch: _searchJson && checkedPinSearch ? _searchJson?.KeySearch : "",
      BranchId: _searchJson && checkedPinSearch ? _searchJson?.BranchId : "",
      FromDate:
        _searchJson && checkedPinSearch
          ? _searchJson?.FromDate
          : new Date(
              new Date(new Date().setMonth(new Date().getMonth() - 1)).getTime() +
                7 * 60 * 60 * 1000,
            )?.toISOString(),
      ToDate:
        _searchJson && checkedPinSearch
          ? _searchJson?.ToDate
          : new Date(new Date().getTime() + 7 * 60 * 60 * 1000)?.toISOString(),
      SubInvCode: _searchJson && checkedPinSearch ? _searchJson?.SubInvCode : "",
    }),
    [],
  );

  const formSeachInput = useForm({
    mode: "uncontrolled",
    initialValues: innitStateSearch,
  });

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);

    try {
      // Tạo URLSearchParams để quản lý các tham số
      const params = new URLSearchParams();

      // Thêm thông tin phân trang
      params.append(
        "Skip",
        (pagination.pageIndex * pagination.pageSize).toString(),
      );
      params.append("Take", pagination.pageSize.toString());

      // Lấy giá trị từ form và thêm vào params nếu có giá trị
      const { KeySearch, BranchId, FromDate, ToDate, SubInvCode } =
        formSeachInput.getValues();
      if (KeySearch) params.append("KeySearch", KeySearch);
      if (BranchId) params.append("BranchId", BranchId);
      if (FromDate) params.append("FromDate", FromDate);
      if (ToDate) params.append("ToDate", ToDate);
      if (SubInvCode) params.append("SubInvCode", SubInvCode);

      const url = `/api/v1/DefectiveItemsList/get-list-warranty-inventory-report?${params.toString()}`;

      const response = await repositoryDelivery.get<MessageResponse<any>>(
        `${url}`,
      );
      if (response && response.success) {
        const result = response.data;
        setData(result);
        setRowCount(response.totalCount);
      } else {
        setData([]);
        setRowCount(0);
        setIsLoading(false);
      }
    } catch (error) {
      setData([]);
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify({ ...formSeachInput.getValues() }),
      );
    }
  };

  // call chi nhánh
  const fetchDataBranch = async () => {
    const dataApi = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblDmInventory/get-select-branch",
    );

    if (dataApi && dataApi.success) {
      const filteredData = dataApi.data.slice(1);
      setDataBranch(filteredData);
    }
  };
  // call kho
  const DataInvCode = async () => {
    try {
      const response = await repositoryDelivery.get(
        `/api/v1/TblDmInventory/get-all?checkAuth=false&isAll=false&select=true`,
      );
      if (response && response.httpStatusCode === 200) {
        const transformedData = response.data
          .filter((i: any) => i.code && i.name)
          .map((item: any) => {
            return {
              value: item.code,
              label: item.code + " - " + item.name,
            };
          });
        const uniqueData = Array.from(
          new Set(transformedData.map((item: any) => item.value)),
        ).map((value) =>
          transformedData.find((item: any) => item.value === value),
        );
        setDataInvCode(uniqueData);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };
  const getColumnPinningStorage = (): ColumnPinningType => {
    const stored = localStorage.getItem("columnPinningInventoryRecord");
    return stored
      ? JSON.parse(stored)
      : {
          left: ["ma_vt"],
          right: [],
        };
  };

  const [columnPinning, setColumnPinning] = useState<ColumnPinningType>(
    getColumnPinningStorage(),
  );

  useEffect(() => {
    localStorage.setItem(
      "columnPinningInventoryRecord",
      JSON.stringify(columnPinning),
    );
  }, [columnPinning]);

  const columns = React.useMemo<MRT_ColumnDef<DeliveryTransaction>[]>(
    () => [
      {
        accessorKey: "ma_vt",
        header: "Mã vật tư",
        Cell: ({ renderedCellValue, row }) =>
          row.index !== 0 ? (
            <>
              <Badge
                variant="dot"
                radius="xs"
                size="md"
                color={renderedCellValue === null ? "red" : green.base}
              >
                {renderedCellValue}
              </Badge>
            </>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "ten_vt",
        header: "Tên vật tư",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
        size: 400,
      },
      {
        accessorKey: "tong_hop_ma_kho",
        header: "Loại hàng",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "serials_no_kho",
        header: "Tổng hợp serial nợ kho",
        size: 200,
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "serials_no_khach",
        header: "Tổng hợp serial nợ khách",
        size: 225,
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "serials_kho_gui_ncc",
        header: "Tổng hợp serial kho gửi NCC",
        size: 250,
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "serials_khach_gui_ncc",
        header: "Tổng hợp serial khách gửi NCC",
        size: 250,
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "no_kho",
        header: "Nợ kho",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "no_khach",
        header: "Nợ khách",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "kho_gui_ncc",
        header: "Kho gửi NCC",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "khach_gui_ncc",
        header: "Khách gửi NCC",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "tong_no",
        header: "Tổng nợ",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "tong_gui_ncc",
        header: "Tổng gửi NCC",
        size: 250,
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
    ],
    [],
  );

  const table = useMantineReactTable({
    columns,
    data: data || [],
    enableColumnResizing: true,
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    mantineTableBodyRowProps: ({ row }) => ({
      style: {
        color: row.original.ten_vt === "TỔNG CỘNG" ? "red" : undefined,
        fontWeight: row.original.ten_vt === "TỔNG CỘNG" ? "bold" : undefined,
      },
    }),
    initialState: {
      showColumnFilters: false,
      columnPinning: { ...columnPinning },
      columnVisibility: { id: true },
      density: "xs",
    },
    enableRowSelection: false,
    mantineTableContainerProps: {
      style: { maxHeight: height - 100, minHeight: height - 100 },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    enableColumnFilters: false,
    enableSorting: false,
    enableColumnActions: true,
    onColumnPinningChange: (newState: any) => {
      setColumnPinning(newState);
    },
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    rowCount,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    onGlobalFilterChange: setGlobalFilter,
    onColumnFiltersChange: setColumnFilters,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "550",
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      sorting,
      rowSelection,
      columnPinning,
    },
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
  });

  const exportDataExcel = async () => {
    open(); // Hiển thị loading
    try {
      // Khởi tạo URL với các tham số phân trang
      const params = new URLSearchParams();

      // Thêm thông tin phân trang
      params.append(
        "Skip",
        (pagination.pageIndex * pagination.pageSize).toString(),
      );
      params.append("Take", pagination.pageSize.toString());

      // Lấy giá trị từ form và thêm vào params nếu có giá trị
      const { KeySearch, BranchId, FromDate, ToDate, SubInvCode } =
        formSeachInput.getValues();
      if (KeySearch) params.append("KeySearch", KeySearch);
      if (BranchId) params.append("BranchId", BranchId);
      if (FromDate) params.append("FromDate", FromDate);
      if (ToDate) params.append("ToDate", ToDate);
      if (SubInvCode) params.append("SubInvCode", SubInvCode);
      // Xây dựng URL API cuối cùng
      const baseUrl = `/api/v1/ExportExcel/export-warranty-inventory-report?${params.toString()}`;

      const _url = BASE_API_DELIVERY + baseUrl;
      const fullUrl = new URL(_url);
      const token = localStorage.getItem("token");

      // Gọi API
      const response = await fetch(fullUrl.toString(), {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token?.replace(/"/g, "")}`,
          "Content-Type": "application/vnd.ms-excel",
        },
      });
      // Kiểm tra trạng thái HTTP
      if (!response.ok) {
        const errorResponse = await response.json(); // Parse lỗi từ API
        const errorMessage =
          errorResponse?.message || "Đã xảy ra lỗi khi xuất dữ liệu!";
        throw new Error(errorMessage); // Ném lỗi để xử lý trong `catch`
      }

      // Xử lý file Excel
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const filename = "bien-ban-kiem-ke-bao-hanh.xlsx"; // Tên mặc định nếu không có header
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (error: any) {
      console.error("Error:", error);
      // Hiển thị thông báo lỗi
      NotificationExtension.Fails(
        error.message || "Đã xảy ra lỗi không xác định!",
      );
    } finally {
      close(); // Đóng loading
    }
  };
  useEffect(() => {
    fetchDataBranch();
  }, []);
  useEffect(() => {
    fetchData();
  }, [pagination]);

  const formatCurrencyVND = (value: any) => {
    if (value == null) {
      return "";
    }
    // Định dạng số theo chuẩn Việt Nam
    return value.toLocaleString("vi-VN", {
      minimumFractionDigits: 0, // Không hiển thị phần thập phân
      maximumFractionDigits: 0, // Đảm bảo không có chữ số sau dấu phẩy
    });
  };

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 190 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (150 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  return (
    <Box pos="relative">
      <LoadingOverlayCustom visible={visible} />
      <Flex
        justify="space-between"
        align="center"
        style={{
          border: "1px solid #dee2e6",
          padding: "5px 10px",
        }}
      >
        <BreadcrumbLayout1></BreadcrumbLayout1>
        <Button
          leftSection={
            <IconFileExport style={{ width: rem(14), height: rem(14) }} />
          }
          onClick={() => exportDataExcel()}
        >
          Export Excel
        </Button>
      </Flex>
      <Box
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          flexWrap: "wrap",
          // marginTop: "10px",
        }}
      >
        <Grid style={{ width: "100%" }} mt={10}>
          <Grid.Col span={sizeGrid}>
            <TextInput
              placeholder="Nhập từ khóa"
              leftSection={<IconSearch color="#15aabf" />}
              key={formSeachInput.key("KeySearch")}
              {...formSeachInput.getInputProps("KeySearch")}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  await fetchData();
                }
              }}
            />
          </Grid.Col>

          <Grid.Col span={sizeGrid}>
            <Select
              searchable
              clearable
              placeholder="Chọn chi nhánh"
              size="sm"
              leftSection={<IconBrandBootstrap color="#15aabf" />}
              data={dataBranch.map((item: any) => {
                return {
                  label: `${item?.att2} - ${item?.text}`,
                  value: String(item?.value ?? ""),
                };
              })}
              value={
                dataBranch.length > 0 ? formSeachInput.getValues().BranchId : ""
              }
              onChange={async (e) => {
                formSeachInput.setFieldValue("BranchId", e ? e.toString() : "");
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              size="sm"
              placeholder="Chọn ngày bắt đầu"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
              value={
                formSeachInput.getValues()?.FromDate &&
                formSeachInput.getValues()?.FromDate.length > 0
                  ? new Date(formSeachInput.getValues()?.FromDate)
                  : null
              }
              maxDate={
                formSeachInput.getValues()?.ToDate &&
                formSeachInput.getValues()?.ToDate.length > 0
                  ? new Date(formSeachInput.getValues()?.ToDate)
                  : new Date()
              }
              onChange={(date) =>
                formSeachInput.setFieldValue(
                  "FromDate",
                  date ? dayjs(date).format("YYYY-MM-DDTHH:mm:ss") : "",
                )
              }
              clearable
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              size="sm"
              placeholder="Chọn ngày kết thúc"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
              value={
                formSeachInput.getValues()?.ToDate &&
                formSeachInput.getValues()?.ToDate.length > 0
                  ? new Date(formSeachInput.getValues()?.ToDate)
                  : null
              }
              minDate={
                formSeachInput.getValues()?.FromDate &&
                formSeachInput.getValues()?.FromDate.length > 0
                  ? new Date(formSeachInput.getValues()?.FromDate)
                  : undefined
              }
              onChange={(date) =>
                formSeachInput.setFieldValue(
                  "ToDate",
                  date ? dayjs(date).format("YYYY-MM-DDTHH:mm:ss") : "",
                )
              }
              clearable
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              size="sm"
              placeholder="Chọn kho"
              leftSection={<IconBuildingWarehouse size={20} color="#15aabf" />}
              data={dataInvCode}
              onClick={() => {
                if (dataInvCode.length === 0) {
                  DataInvCode();
                }
              }}
              searchable
              key={formSeachInput.key("SubInvCode")}
              {...formSeachInput.getInputProps("SubInvCode")}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Button
              type="submit"
              leftSection={<IconSearch size={20} />}
              color="blue"
              variant="outline"
              onClick={async () => {
                await fetchData();
              }}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </Box>

      <div className="mt-5" style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </Box>
  );
};

export default InventoryRecord;
